import { takeLatest, put, call, all } from 'redux-saga/effects';
import DisplayUnitApi from './display-unit-api';
import DisplayUnitActions from './display-unit-actions';

function* fetchDisplayUnitsHandler({ payload }) {
  try {
    const displayUnits = yield call(DisplayUnitApi.fetchDisplayUnits, payload);
    yield put(DisplayUnitActions.fetchSuccess(displayUnits));
  } catch (error) {
    yield put(DisplayUnitActions.fetchFailure(error));
  }
}

export default function* displayUnitSagas() {
  yield all([takeLatest(DisplayUnitActions.fetch.getType(), fetchDisplayUnitsHandler)]);
}
